import SelectorModel from '../../../models/SelectorModel';

export function buildCategoriasSelector(categorias) {
  return categorias.map(categoria => new SelectorModel(categoria.idCategoria, categoria.nomeCategoria, categoria.tipoDocumento));
}
